import React, { useEffect, useState } from "react";
import AdminTable from "../../Components/AdminTable/AdminTable";
import Select from "react-select";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import Paginator from "../../Components/Paginator/Paginator";
import ApiService from "../../Core/Service/ApiService";
import { useContext } from "react";
import CmsContext from "../../Context/CmsContext";

const BranchList = React.memo(props => {
    const navigate = useNavigate();
    const perPageOptions = [
        {value: 10, label: '10'},
        {value: 20, label: '20'},
        {value: 50, label: '50'},
        {value: 100, label: '100'},
    ]
    const [formData, setFormData] = useState({
        pageNum: 1,
        perPage: 10,
        search: {},
        sort: {}
    })
    const [total, setTotal] = useState(0);
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const cmsContext = useContext(CmsContext);

    useEffect(() => {
        cmsContext.setBreadcrumb([
            { title: cmsContext.currMainMenu?.label ?? ''},
            { title: cmsContext.currSubMenu?.label ?? ''},
            { title: 'List'},
        ])
    }, [])

    const getBranches = async() => {
        setLoading(true);

        const data = {
            ...formData,
            search: JSON.stringify(formData.search),
            sort: JSON.stringify(formData.sort)
        }

        let response = await ApiService.get('/branches', data);
        setTotal(response.data.total);
        setRows(response.data.rows);
        
        setLoading(false);
    }

    useEffect(() => {
        getBranches();
    }, [formData])

    const onPageChanged = (pageNum) => {
        setFormData({
            ...formData,
            pageNum
        })
    }
    const onPerPageChanged = (opt) => {
        setFormData({
            ...formData,
            pageNum: 1,
            perPage: opt.value
        })
    }
    const handleSearch = (search) => {
        setFormData({
            ...formData,
            pageNum: 1,
            search: search
        })
    }
    const handleSort = (sort) => {
        setFormData({
            ...formData,
            pageNum: 1,
            sort: sort
        })
    }

    const onAddBtnClicked = (e) => {
        navigate(`/branch/create`);
    }
    const gotoEdit = (row) => {
        navigate(`/branch/edit/${row.id}`);
    }
    const handleCopy = (row) => {
        navigate(`/branch/copy/${row.id}`);
    }
    const handleDelete = (row) => {
        if(window.confirm("Are you sure to delete?") == false) return;
        ApiService.delete(`/branches/${row.id}`).then(() => {
            getBranches();
        })
    }

    const renderTbodyTr = (row, rowIndex) => {
        let className = "active";
        return (
            <tr key={rowIndex} className={`${className}`}>
                { columns.map((col, colIndex) => {
                    const el = renderTdCell(row, col.data ?? col.name, rowIndex, colIndex);
                    if(el) {
                        return <td key={colIndex}>{el}</td>
                    } else {
                        return <td key={colIndex}>{row[col.name]}</td>
                    }
                })}
            </tr>
        )
    }

    const renderTdCell = (row, colname, rowIndex, colIndex) => {
        switch(colname) {
            case 'action':
                return (
                <div className="d-flex justify-content-end">
                    <MDBBtn color="none" tag="a" onClick={() => gotoEdit(row)} title="Edit User">
                        <MDBIcon fas icon="pencil-alt" size="lg" color="warning" />
                    </MDBBtn>
                    <MDBBtn color="none" tag="a" title="Copy Content" onClick={() => handleCopy(row)}>
                        <MDBIcon far icon='copy' size="lg" className="ms-2" color="warning" />
                    </MDBBtn>
                    <MDBBtn color="none" tag="a" onClick={()=>handleDelete(row)} title="Delete Content">
                        <MDBIcon far icon="trash-alt" size="lg" color="danger" className="ms-2" />
                    </MDBBtn>
                </div>
                )
            default:
                return <div className="cursor-pointer" onClick={e=>gotoEdit(row)}>{row[colname]}</div>;
        }
    }

    const columns = [
        {name: 'site_name', title: 'Site Name', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }}, 
        {name: 'trading_name', title: 'Trading Name', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'email', title: 'Email', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'telephone', title: 'Telephone', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'fax', title: 'Fax', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'address1', title: 'Address1', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'post_code', title: 'Post Code', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'action', title: 'Action', headerClassName: "d-flex justify-content-end"}
    ];

    return (
    <div className="d-flex flex-column h-100">
        <div className="d-flex align-items-center me-1 mt-2">
            <div className="flex-fluid d-flex align-items-center ps-2">
                <label>Per Page:</label>
                <div className="ms-2" style={{width:100}}>
                    <Select 
                        options={perPageOptions} 
                        value={perPageOptions.find(opt=>opt.value == formData.perPage)} 
                        onChange={onPerPageChanged}
                    />
                </div>
                <label className="ms-4">
                    Found 
                    <span className='fw-bold mx-2' style={{color: '#333'}}>{total}</span> 
                    Matching Results.
                </label>
            </div>

            <div className="d-flex align-items-center">
                <MDBBtn className="ms-4" onClick={onAddBtnClicked}>
                    <MDBIcon icon="plus" />
                    <span className="ms-1">Create Branch</span>
                </MDBBtn>
            </div>
        </div>

        <div className="flex-fluid mt-3">
            <AdminTable 
                columns={columns} 
                rows={rows} 
                renderTbodyTr={renderTbodyTr} 
                handleSearch={handleSearch} 
                handleSort={handleSort}
                search={formData.search} 
                sort={formData.sort}
            />
        </div>

        <div className="flex-fluid d-flex justify-content-center mt-4">
            <Paginator curPage={formData.pageNum} total={total} perPage={formData.perPage} onPageChanged={onPageChanged} />
        </div>

        <LoadingIndicator show={loading} />
    </div>
    )
});

export default BranchList;